export const EEventType = {
  "0": "UNKNOWN",
  "1": "MEMCACHE_CLEAN",
  "2": "RATELIMITER_REFRESH",
  "3": "HOTEL_CACHE_FEED_RESULT",
  "-1": "ALL"
};